import React, { useEffect, useState } from 'react'
import HeaderPage from '../components/homePage/HeaderPage'
import FooterPage from '../components/homePage/FooterPage'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
import HeaderUser from '../components/homePage/HeaderUser';




function Disclaimer() {
 
  const { userDetailLogin } = useSelector((state) => state.auth);
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  const [disclaimer, setDisclaimer] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchDisclaimer = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/front/disclaimer`);
      const result = await res.json();
      
      if (result.status && result.data) {
            setDisclaimer(result.data.disclaimer);
        }
    } catch (error) {
      console.error("Disclaimer fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDisclaimer();
  }, []);

  return (
    
    <>
    { userDetailLogin?._id ? <HeaderUser /> : <HeaderPage /> }
    <>
  <section className="inrbnr">
    <div className="container-fluid con-flu-padd">
      <div className="inrbnrContent">
        <h1>Disclaimer</h1>
        <ul className="inrbrnNav">
          <li>
            <Link to={userDetailLogin?._id ? '/dashboard':'/'}>
              <img src="assets/img/icons/home.png" alt="home icon" />
            </Link>
            <img src="assets/img/icons/arrows.png" alt="arrows icons" />
          </li>
          <li>
            <Link to="#">Disclaimer</Link>
          </li>
        </ul>
      </div>
    </div>
  </section>
  {/* Section End */}
  <section>
    <div className="register-sec">
      <div className="container-fluid con-flu-padd term-page">
        <div className='mx-2 py-5'>
          {loading ? (
                <p>Loading...</p>
            ) : (
                <div
                dangerouslySetInnerHTML={{ __html: disclaimer }}
                />
            )}
        </div>
      </div>
    </div>
  </section>
</>



    <FooterPage /> 

     
    </>
    
  )
}

export default Disclaimer
